import SectionTitle from '@/components/feature/SectionTitle';
import ScrollReveal from '@/components/feature/ScrollReveal';

const COMPONENTS = [
  { icon: 'ri-settings-2-line', name: 'Bombas hidráulicas' },
  { icon: 'ri-restart-line', name: 'Motores hidráulicos' },
  { icon: 'ri-tools-line', name: 'Cilindros' },
  { icon: 'ri-contrast-drop-line', name: 'Válvulas' },
  { icon: 'ri-dashboard-3-line', name: 'Bombas de pistão' },
  { icon: 'ri-settings-3-line', name: 'Bombas de engrenagem' },
  { icon: 'ri-settings-4-line', name: 'Bombas de palheta' },
  { icon: 'ri-loop-left-line', name: 'Motores orbitais' },
  { icon: 'ri-filter-line', name: 'Filtros' },
  { icon: 'ri-stack-line', name: 'Kits de vedação' },
  { icon: 'ri-battery-charge-line', name: 'Acumuladores' },
  { icon: 'ri-layout-grid-line', name: 'Blocos manifold' },
  { icon: 'ri-shapes-line', name: 'Unidades hidráulicas' },
  { icon: 'ri-link', name: 'Mangueiras' },
  { icon: 'ri-plug-line', name: 'Conexões' },
];

export default function NewComponentsSection() {
  return (
    <section id="componentes-novos" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-container mx-auto px-4 md:px-6">
        <ScrollReveal>
          <SectionTitle
            overline="Nova solução"
            title="Componentes Hidráulicos Novos"
            description="Quando a substituição é a melhor solução, fornecemos componentes hidráulicos novos para máquinas pesadas, equipamentos móveis e sistemas industriais."
          />
        </ScrollReveal>

        <div className="mt-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-4">
            {COMPONENTS.map((item, i) => (
              <ScrollReveal key={i} delay={i * 40}>
                <div className="flex items-center gap-3 text-foreground-700">
                  <div className="w-8 h-8 flex items-center justify-center text-primary-500 flex-shrink-0">
                    <i className={`${item.icon} text-lg`}></i>
                  </div>
                  <span className="text-sm font-medium">{item.name}</span>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}